import { HTMLAttributes } from "react"

// Icon fonts are loaded globally from assets/scss/icons.scss, so the class name is
// all an icon needs. Caller className is appended, not replaced, so colour utilities
// (text-danger, etc.) and spacing classes stack on top of the glyph.
type IconProps = HTMLAttributes<HTMLElement>

export const PencilIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-pencil ${className}`.trim()} {...props} />
)

export const CloseCircleIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-close-circle-outline ${className}`.trim()} {...props} />
)

export const PermissionsIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-shield-key-outline ${className}`.trim()} {...props} />
)

export const TrashIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-trash-can-outline text-danger ${className}`.trim()} {...props} />
)

export const CheckCircleIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-check-circle-outline ${className}`.trim()} {...props} />
)

export const AlertCircleIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-alert-circle-outline ${className}`.trim()} {...props} />
)

export const ResetPasswordIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-lock-reset ${className}`.trim()} {...props} />
)

export const AccountOffIcon =({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-account-off-outline ${className}`.trim()} {...props} />
)

export const ControlsIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-tune ${className}`.trim()} {...props} />
)

export const FitIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-fit-to-page-outline ${className}`.trim()} {...props} />
)

export const SwapIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-swap-horizontal ${className}`.trim()} {...props} />
)

export const CompactIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-view-compact-outline ${className}`.trim()} {...props} />
)

export const FullscreenIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-fullscreen ${className}`.trim()} {...props} />
)

export const ImageIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-image-outline ${className}`.trim()} {...props} />
)

export const SvgIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-svg ${className}`.trim()} {...props} />
)

export const PdfIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-file-pdf-box ${className}`.trim()} {...props} />
)

export const ExpandAllIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-arrow-expand-vertical ${className}`.trim()} {...props} />
)

export const CollapseAllIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-arrow-collapse-vertical ${className}`.trim()} {...props} />
)

export const ZoomInIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-magnify-plus-outline ${className}`.trim()} {...props} />
)

export const ZoomOutIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-magnify-minus-outline ${className}`.trim()} {...props} />
)

export const PackageIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-package-variant-closed ${className}`.trim()} {...props} />
)

export const ChartIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-chart-bar ${className}`.trim()} {...props} />
)

export const DownloadIcon =({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-download ${className}`.trim()} {...props} />
)

export const HelpIcon =({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-help-circle-outline ${className}`.trim()} {...props} />
)

export const SyncIcon =({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-sync ${className}`.trim()} {...props} />
)

export const DocumentIcon =({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-file-document-outline ${className}`.trim()} {...props} />
)

export const ConstructionIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-traffic-cone ${className}`.trim()} {...props} />
)

export const BriefcaseIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-briefcase-outline ${className}`.trim()} {...props} />
)

export const ChevronRightIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-chevron-right ${className}`.trim()} {...props} />
)

export const ChevronDownIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-chevron-down ${className}`.trim()} {...props} />
)

export const DotsVerticalIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-dots-vertical ${className}`.trim()} {...props} />
)

export const PlusIcon =({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-plus ${className}`.trim()} {...props} />
)

export const ViewIcon =({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-eye-outline ${className}`.trim()} {...props} />
)

export const HiddenIcon =({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-eye-off-outline ${className}`.trim()} {...props} />
)

export const MoonIcon =({ className = "", ...props }: IconProps) => (
    <i className={`bx bx-moon ${className}`.trim()} {...props} />
)

export const SunIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`bx bx-sun ${className}`.trim()} {...props} />
)

export const PrintIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-printer-outline ${className}`.trim()} {...props} />
)

export const ExportIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-file-export-outline ${className}`.trim()} {...props} />
)

export const InfoIcon = ({ className = "", ...props }: IconProps) => (
    <i className={`mdi mdi-information-outline ${className}`.trim()} {...props} />
)
